export const getItem = (name) => {
    const item = localStorage.getItem(name);
    if (item) return JSON.parse(item);
    else return "";
};

export const setItem = (name, value) => {
    localStorage.setItem(name, JSON.stringify(value));
};
